<mat-sidenav-container class="example-container">
  <mat-sidenav
    #drawer
    (closed)="closeDrawer()"
    [opened]="siteStore.openDrawer()"
    mode="over"
    position="end"
    fixedInViewport="true"
  >
    <div class="h-full">
      <div class="flex flex-col h-full overflow-y-hidden">
        <div class="relative px-4 pt-6 app-gradient h-15 sm:px-6">
          <div class="absolute top-0 w-full h-full overflow-hidden left-0 opacity-30">
            <app-gradient-background></app-gradient-background>
          </div>
          <div class="justify-between w-full flex-center">
            <div class="flex-col mb-2 text-center flex-center">
              <h2 class="font-medium text-white sm:text-lg" id="slide-over-title">
                {{ authStore.userFullName() }}
              </h2>
              <span class="text-white">{{ authStore.user().email }}</span>
              <div
                class="z-10 flex w-16 h-16 p-2 mt-3 -mb-10 text-sm text-white sm:bg-white bg-white/80 backdrop-blur-md rounded-full shadow-xl flex-center"
              >
                <b class="text-2xl text-primary-800 uppercase">{{ authStore.userInitials() }}</b>
              </div>
            </div>
            <div class="absolute flex items-center ml-3 top-5 right-5 h-7">
              <button
                (click)="siteStore.openDrawer.set(false)"
                type="button"
                class="text-white/60 bg-white/10 rounded-full p-1 outline-none hover:text-white"
              >
                <span class="sr-only">Close panel</span>
                <svg
                  class="w-6 h-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div
          class="sm:bg-white bg-white/70 backdrop-blur-md flex flex-1 overflow-auto flex-col relative"
        >
          <div class="flex-1 px-4 py-6 sm:px-6 space-y-3">
            <h3
              class="text-sm font-semibold tracking-wider text-gray-500 uppercase"
              id="projects-headline"
            >
              Perfil
            </h3>
            <a class="block" (click)="closeDrawer()" [routerLink]="['/qr/share']">
              <div
                matRipple
                class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
              >
                <div class="flex items-center justify-center space-x-3">
                  <app-qr-icon class="text-primary-800"></app-qr-icon>
                  <div class="flex flex-col">
                    <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Mi QR</h2>
                  </div>
                </div>
              </div>
            </a>

            <a
              class="block"
              (click)="closeDrawer()"
              [routerLink]="siteStore.$bp().sm ? ['/settings'] : ['/settings/profile']"
            >
              <div
                matRipple
                class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
              >
                <div class="flex items-center justify-center space-x-3">
                  <app-user-icon class="text-primary-800"></app-user-icon>
                  <div class="flex flex-col">
                    <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Ajustes</h2>
                  </div>
                </div>
              </div>
            </a>

            <a class="block" (click)="closeDrawer()" [routerLink]="['/settings/security']">
              <div
                matRipple
                class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
              >
                <div class="flex items-center justify-center space-x-3">
                  <app-security-icon class="text-primary-800"></app-security-icon>
                  <div class="flex flex-col">
                    <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Seguridad</h2>
                  </div>
                </div>
              </div>
            </a>

            <a class="block" (click)="closeDrawer()" [routerLink]="['/notifications']">
              <div
                matRipple
                class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
              >
                <div class="flex items-center justify-center space-x-3">
                  <app-notification-icon class="text-primary-800"></app-notification-icon>
                  <div class="flex flex-col">
                    <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Notificaciones</h2>
                    <div class="flex items-center gap-1.5">
                      @if (notificationStore.hasUnread()) {
                        <span class="inline-block h-2 w-2 rounded-full bg-red-500"></span>
                        <span class="text-xs text-gray-500">
                          {{ notificationStore.unreadCount() }}
                          {{
                            notificationStore.unreadCount() === 1
                              ? 'notificación nueva'
                              : 'notificaciones nuevas'
                          }}
                        </span>
                      } @else {
                        <span class="text-xs text-gray-500">Sin notificaciones nuevas</span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </a>

            <!-- Novedades: Actualizaciones de la app (visible a todos) -->
            <a class="block" (click)="closeDrawer()" [routerLink]="['/app-updates/updates']">
              <div
                matRipple
                class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
              >
                <div class="flex items-center justify-center space-x-3">
                  <app-app-update-icon class="text-primary-800"></app-app-update-icon>
                  <div class="flex flex-col">
                    <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Actualizaciones</h2>
                    <div class="flex items-center gap-1.5">
                      @if (appUpdatesStore.hasUpdatesUnread()) {
                        <span class="inline-block h-2 w-2 rounded-full bg-red-500"></span>
                        <span class="text-xs text-gray-500">
                          {{ appUpdatesStore.updatesUnread() }}
                          {{ appUpdatesStore.updatesUnread() === 1 ? 'novedad nueva' : 'novedades nuevas' }}
                        </span>
                      } @else {
                        <span class="text-xs text-gray-500">Cambios de la app</span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </a>

            <!-- Novedades: Anuncios (visible a todos) — OCULTO temporalmente a pedido -->
            <!-- <a class="block" (click)="closeDrawer()" [routerLink]="['/app-updates/announcements']">
              <div
                matRipple
                class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
              >
                <div class="flex items-center justify-center space-x-3">
                  <app-announcement-icon class="text-primary-800"></app-announcement-icon>
                  <div class="flex flex-col">
                    <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Anuncios</h2>
                    <div class="flex items-center gap-1.5">
                      @if (appUpdatesStore.hasAnnouncementsUnread()) {
                        <span class="inline-block h-2 w-2 rounded-full bg-red-500"></span>
                        <span class="text-xs text-gray-500">
                          {{ appUpdatesStore.announcementsUnread() }}
                          {{ appUpdatesStore.announcementsUnread() === 1 ? 'anuncio nuevo' : 'anuncios nuevos' }}
                        </span>
                      } @else {
                        <span class="text-xs text-gray-500">Novedades y promociones</span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </a> -->

            <!-- Subastas (visible a todos) -->
            <a class="block" (click)="closeDrawer()" [routerLink]="['/auctions']">
              <div
                matRipple
                class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
              >
                <div class="flex items-center justify-center space-x-3">
                  <app-auction-icon class="text-primary-800"></app-auction-icon>
                  <div class="flex flex-col">
                    <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Subastas</h2>
                    <span class="text-xs text-gray-500">Puja en subastas activas</span>
                  </div>
                </div>
              </div>
            </a>

            <!-- Estadísticas: disponible para cualquier tipo de cuenta -->
            <a class="block" (click)="closeDrawer()" [routerLink]="['/statistics']">
              <div
                matRipple
                class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
              >
                <div class="flex items-center justify-center space-x-3">
                  <app-statistics-icon class="text-primary-800"></app-statistics-icon>
                  <div class="flex flex-col">
                    <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Estadísticas</h2>
                    <span class="text-xs text-gray-500">Ingresos y gastos de tu cuenta</span>
                  </div>
                </div>
              </div>
            </a>

            <!-- Cobros: solo para cuentas con la etiqueta "merchant" (comercios) -->
            @if (bankAccountsStore.isSelectedMerchantAccount()) {
              <a class="block" (click)="closeDrawer()" [routerLink]="['/collections']">
                <div
                  matRipple
                  class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
                >
                  <div class="flex items-center justify-center space-x-3">
                    <app-bag-icon size="32" class="text-primary-800"></app-bag-icon>
                    <div class="flex flex-col">
                      <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Cobros</h2>
                      <span class="text-xs text-gray-500">Pagos recibidos en tu comercio</span>
                    </div>
                  </div>
                </div>
              </a>
            }

            <!-- Only show Deudas pendientes link if there are pending debts -->
            <!-- <a
              class="block"
              *ngIf="debtsStore.hasPendingDebts()"
              (click)="closeDrawer()"
              [routerLink]="['/debts']"
            >
              <div
                matRipple
                class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
              >
                <div class="flex items-center justify-center space-x-3">
                  <app-debt-icon class="text-primary-800"></app-debt-icon>
                  <div class="flex flex-col">
                    <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Deudas pendientes</h2>
                  </div>
                </div>
              </div>
            </a> -->

            <!-- <a class="block" (click)="closeDrawer()" [routerLink]="['/analytics']">
							<div
								matRipple
								class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
							>
								<div class="flex items-center justify-center space-x-3">
									<app-chart-icon class="text-primary-800"></app-chart-icon>
									<div class="flex flex-col">
										<h2 class="mb-0 font-medium sm:text-lg text-slate-900">Gráficos</h2>
									</div>
								</div>
							</div>
						</a> -->

            <div class="w-full py-1 border-b border-gray-200 border-1"></div>
            <h3
              class="!mt-6 text-sm font-semibold tracking-wider text-gray-500 uppercase"
              id="projects-headline"
            >
              Sesión
            </h3>
            <div
              (click)="logout()"
              matRipple
              class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
            >
              <div class="flex items-center justify-center space-x-3">
                <app-logout-icon class="text-primary-800"></app-logout-icon>
                <div class="flex flex-col">
                  <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Cerrar mi sesión</h2>
                </div>
              </div>
            </div>

            <div class="w-full py-1 border-b border-gray-200 border-1"></div>
            <h3
              class="!mt-6 text-sm font-semibold tracking-wider text-gray-500 uppercase"
              id="projects-headline"
            >
              Ayuda
            </h3>
            <a class="block" (click)="closeDrawer()" [routerLink]="['/help-center']">
              <div
                matRipple
                class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
              >
                <div class="flex items-center justify-center space-x-3">
                  <app-help-icon class="text-primary-800"></app-help-icon>
                  <div class="flex flex-col">
                    <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Ayuda</h2>
                  </div>
                </div>
              </div>
            </a>

            <!-- API de integración (visible a todos) -->
            <a class="block" (click)="closeDrawer()" [routerLink]="['/integration-api']">
              <div
                matRipple
                class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
              >
                <div class="flex items-center justify-center space-x-3">
                  <app-api-icon class="text-primary-800" iconClass="text-primary-800"></app-api-icon>
                  <div class="flex flex-col">
                    <h2 class="mb-0 font-medium sm:text-lg text-slate-900">API de integración</h2>
                    <span class="text-xs text-gray-500">Conecta tus sistemas con SuperPay</span>
                  </div>
                </div>
              </div>
            </a>

            @if (supportChatStore.hasConversation()) {
              <a class="block cursor-pointer" (click)="openSupportChat()">
                <div
                  matRipple
                  class="hoverable-card !bg-white/50 !p-2 rounded-full flex items-start !ring-0 hover:!ring-2 !border-0"
                >
                  <div class="flex items-center justify-center space-x-3 w-full">
                    <app-support-chat-icon class="text-primary-800"></app-support-chat-icon>
                    <div class="flex flex-col flex-1">
                      <h2 class="mb-0 font-medium sm:text-lg text-slate-900">Chat de soporte Crypto</h2>
                    </div>
                    @if (supportChatStore.unreadCount() > 0) {
                      <span
                        class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[11px] font-bold"
                      >
                        {{ supportChatStore.unreadCount() > 99 ? '99+' : supportChatStore.unreadCount() }}
                      </span>
                    }
                  </div>
                </div>
              </a>
            }

            <div class="w-full py-1 border-b border-gray-200 border-1"></div>
            <h3
              class="!mt-6 text-sm font-semibold tracking-wider text-gray-500 uppercase"
              id="projects-headline"
            >
              Nuestros enlaces
            </h3>
            <div class="flex flex-row items-center justify-start space-x-3">
              <a href="mailto:soporte@superpay23.com">
                <div
                  matRipple
                  class="hoverable-card !bg-white/50 !rounded-full !w-min !p-2 flex items-start !ring-0 hover:!ring-2 !border-0"
                >
                  <div class="flex items-center justify-center space-x-3">
                    <app-email-icon
                      [width]="'27'"
                      [height]="'27'"
                      class="text-gray-500"
                    ></app-email-icon>
                  </div>
                </div>
              </a>
              <a href="https://t.me/superpay_23" target="_blank">
                <div
                  matRipple
                  class="hoverable-card !bg-white/50 !rounded-full !w-min !p-2 flex items-start !ring-0 hover:!ring-2 !border-0"
                >
                  <div class="flex items-center justify-center space-x-3">
                    <app-telegram-icon></app-telegram-icon>
                  </div>
                </div>
              </a>
            </div>
          </div>

          <app-update-pwa-button
            [customClass]="'z-10 !m-0 !relative !mt-auto min-h-14 !bottom-0  !w-full rounded-none'"
          ></app-update-pwa-button>

          <span
            [ngClass]="{
              '!text-white': pwaStore.showInstallButton() || pwaStore.showUpdateButton()
            }"
            class="absolute text-xs bottom-0 text-black font-bold z-50 right-1 opacity-80"
          >
            v{{ appVersion }}
          </span>
        </div>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
